import React from "react";

export const SharedLoaderSpinner = () => {
	return (
		<div className="loader__spinner">
			<div className="loader__spinner__wrapper">
				<div />
				<div />
				<div />
			</div>
		</div>
	);
};
